<div class="container-fluid">
    <div style="background-color:#D7D7D7; border-bottom:1px grey solid; padding:25px;" *ngIf="customHTMLHeaderOnCareersSafeHtml === null">
        <img style="max-height:260px;max-width: 500px" id="logoHeader" [src]="logoUrl" alt="" />
    </div>
    <div [innerHTML]="customHTMLHeaderOnCareersSafeHtml" *ngIf="customHTMLHeaderOnCareersSafeHtml"></div>
    <div class="row mt-3 mb-3">
        <div class="col-lg-2 col-md-2 col-sm-2"></div>
        <div class="col-lg-8 col-md-8 col-sm-8">
            <h3>Current Positions</h3>
            <hr />
            <div class="mobile-filter row d-block d-lg-none" *ngIf="!hideCareerFilter">
                <div class="col-lg-6 col-md-6">
                    <div class="row">
                        <button class="btn btn-default" type="button"
                                data-toggle="collapse"
                                data-target="#mobile-filters-toggle"
                                aria-expanded="true"
                                aria-controls="mobile-filters-toggle"
                                (click)="expandedFilter = !expandedFilter">
                            Filters
                            <span class="modus-icons align-bottom" *ngIf="expandedFilter">minus</span><span class="modus-icons align-bottom" *ngIf="!expandedFilter">add</span>
                        </button>
                    </div>
                    <div id="mobile-filters-toggle" class="collapse">
                        <div class="row mt-2">
                            <h4 style="color: {{browseJobsColor}};">Filter By Company</h4>
                            <div>
                                <ul style="list-style: none;padding-left:20px;">
                                    <li *ngFor="let data of companyFilters">
                                        <input type="checkbox" [(ngModel)]="data.IsSelected" (change)="updateFilteredJobs()" /> {{ data.DisplayValue }}

                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <h4 style="color: {{browseJobsColor}};">Filter By Location</h4>
                                <div>
                                    <ul style="list-style: none;padding-left:20px;">
                                        <li *ngFor="let filterByState of groupedLocations | keyvalue">
                                            <input type="checkbox" [(ngModel)]="filterByState.value[0].IsStateSelected" (change)="stateFilterChanged(filterByState.value)" />
                                            <a (click)="updateShowCity(filterByState.value[0])" href="#">{{filterByState.value[0].StateDisplayValue}}</a>
                                            <span class="modus-icons align-bottom" *ngIf="!filterByState.value[0].showCity" (click)="updateShowCity(filterByState.value[0])" style="cursor:pointer;">add</span>
                                            <span class="modus-icons align-bottom" *ngIf="filterByState.value[0].showCity" (click)="updateShowCity(filterByState.value[0])" style="cursor:pointer;">minus</span>
                                            <ul style="list-style: none;">
                                                <ng-container *ngFor="let filterByCity of filterByState.value">
                                                    <li *ngIf="filterByState.value[0].showCity">
                                                        <input type="checkbox" [(ngModel)]="filterByCity.IsCitySelected" (change)="cityFilterChanged(filterByState.value)" /> {{filterByCity.CityValue}}
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <h4 style="color: {{ browseJobsColor }};">Filter By Title</h4>
                                <div>
                                    <ul class="list-unstyled pl-3">
                                        <ng-container *ngFor="let filter of templateFilters">
                                            <li *ngIf="filter.ShowInFilter">
                                                <input type="checkbox" [(ngModel)]="filter.IsSelected" (change)="updateFilteredJobs()" />{{ filter.DisplayValue }}
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="!hideCategoryFromCareersPage">
                            <div class="col-12">
                                <h4 style="color: {{ browseJobsColor }};">Filter By Category</h4>
                                <div>
                                    <ul style="list-style: none; padding-left: 20px;">
                                        <ng-container *ngFor="let filter of categoryFilters">
                                            <li *ngIf="filter.ShowInFilter">
                                                <input type="checkbox" [(ngModel)]="filter.IsSelected" (change)="updateFilteredJobs()" /> {{ filter.DisplayValue }}
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row bg-light">
                <div class="col-lg-5 col-md-5 pb-3">
                    <label><strong>Search Jobs:</strong></label>
                    <div class="input-group">
                        <input type="text" class="form-control" (keypress)="searchJobsEvent($event)" [(ngModel)]="filterValues.searchText" />
                        <div class="input-group-append">
                            <button class="btn btn-default"
                                    [style.background-color]="browseJobsColor"
                                    [style.color]="'white'"
                                    (click)="searchJobs()">
                                Search
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 pb-3" *ngIf="!hideCareerFilter">
                    <button class="btn btn-outline-dark buttonNoLabel bg-white" type="button" (click)="removeAllFilters()">Remove Filters</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2"></div>
        <div class="col-lg-6 col-md-6 col-sm-6">
            <div *ngIf="pagedJobRequisitions.length < 1">
                There are no open jobs that match the search criteria.
            </div>
            <div *ngIf="pagedJobRequisitions.length > 0">
                <div *ngFor="let job of pagedJobRequisitions" class="clickableRow" style="margin-bottom: 16px; cursor: pointer; word-wrap: break-word;" (click)="goToJobDetail(job)">
                    <b style="margin-bottom: 5px; color: {{ browseJobsColor }}; font-size: 18px;">{{ job.PositionTitle }} <span *ngIf="showRequisitionNumberOnExternalATSPosting">(Req #: {{ job.ReqNum }})</span></b>
                    <br />
                    {{ job.City }}, {{ job.State }} - Posted on {{ job.DatePostedDisplayValue }}
                </div>
                <pagination [totalItems]="jobRequisitions?.length"
                            class="pagination-md"
                            [(ngModel)]="formData.currentPage"
                            (ngModelChange)="updateFilteredDocuments()"
                            [itemsPerPage]="formData.itemsPerPage"
                            [maxSize]="10">
                </pagination>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 d-none d-lg-block" *ngIf="!hideCareerFilter">
            <div class="row">
                <div class="col-12">
                    <h4 style="color: {{browseJobsColor}};">Filter By Company</h4>
                    <div>
                        <ul style="list-style: none;padding-left:20px;">
                            <li *ngFor="let data of companyFilters">
                                <input type="checkbox" [(ngModel)]="data.IsSelected" (change)="updateFilteredJobs()" /> {{data.DisplayValue}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h4 style="color: {{browseJobsColor}};">Filter By Location</h4>
                    <div>
                        <ul style="list-style: none;padding-left:20px;">
                            <li *ngFor="let filterByState of groupedLocations | keyvalue">
                                <input type="checkbox" [(ngModel)]="filterByState.value[0].IsStateSelected" (change)="stateFilterChanged(filterByState.value)" />
                                <a (click)="updateShowCity(filterByState.value[0])" href="#">{{filterByState.value[0].StateDisplayValue}}</a>
                                <span class="modus-icons align-bottom" *ngIf="!filterByState.value[0].showCity" (click)="updateShowCity(filterByState.value[0])" style="cursor:pointer;">add</span>
                                <span class="modus-icons align-bottom" *ngIf="filterByState.value[0].showCity" (click)="updateShowCity(filterByState.value[0])" style="cursor:pointer;">minus</span>
                                <ul style="list-style: none;">
                                    <ng-container *ngFor="let filterByCity of filterByState.value">
                                        <li *ngIf="filterByState.value[0].showCity">
                                            <input type="checkbox" [(ngModel)]="filterByCity.IsCitySelected" (change)="cityFilterChanged(filterByState.value)" /> {{filterByCity.CityValue}}
                                        </li>
                                    </ng-container>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h4 style="color: {{browseJobsColor}};">Filter By Title</h4>
                    <div>
                        <ul style="list-style: none; padding-left: 20px;">
                            <ng-container *ngFor="let filter of templateFilters">
                                <li *ngIf="filter.ShowInFilter">
                                    <input type="checkbox" [(ngModel)]="filter.IsSelected" (change)="updateFilteredJobs()" /> {{ filter.DisplayValue }}
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!hideCategoryFromCareersPage">
                <div class="col-12">
                    <h4 style="color: {{browseJobsColor}};">Filter By Category</h4>
                    <div>
                        <ul style="list-style: none; padding-left: 20px;">
                            <ng-container *ngFor="let filter of categoryFilters">
                                <li *ngIf="filter.ShowInFilter">
                                    <input type="checkbox" [(ngModel)]="filter.IsSelected" (change)="updateFilteredJobs()" /> {{ filter.DisplayValue }}
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
